export function ProposalPurposeFactory() {
    return function ProposalPurpose() {
        this.id = null;
        this.code = null;
        this.name = null;
    };
}
